/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RelationshipType } from './relationshipType';


export interface Relation { 
    fromEntity: string;
    fromEntityId: object;
    toEntity: string;
    toEntityId: object;
    relationshipType: RelationshipType;
}

